import {
  Box,
  Checkbox,
  TableRow,
  TableCell,
  TableHead,
  TableSortLabel,
} from '@mui/material';

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
};

interface UserListHeadProps {
  order?: 'asc' | 'desc';
  orderBy?: string;
  rowCount?: number;
  headLabel: any[];
  numSelected?: number;
  onRequestSort?: (event: any, property: any) => void;
  onSelectAllClick?: (event: any) => void;
}

export default function UserListHead({
  order,
  orderBy,
  rowCount = 0,
  headLabel,
  numSelected = 0,
  onRequestSort,
  onSelectAllClick,
}: UserListHeadProps) {
  const createSortHandler = (property: any) => (event: any) => {
    onRequestSort?.(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {onSelectAllClick && (
          <TableCell padding='checkbox'>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell>
        )}
        {headLabel.map((headCell: any) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignRight ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              hideSortIcon
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box sx={{ ...visuallyHidden }}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
